module.exports = __webpack_public_path__ + "img/blt-arrow01_r.6a69ada0.svg";